<mat-dialog-content>
    <div class="px-16 py-8">
        <div class="flex items-center gap-5">
            <fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
            <h5 class="m-0 text-[16px] font-weight">{{ data?.confirmMessage }}</h5>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-center gap-3">
    <button matButton="outlined" type="button" (click)="onConfirmation(false)"> {{
        data?.closeBtnText }} </button>
    <button matButton="filled" type="submit" (click)="onConfirmation(true)">{{ data?.saveBtnText
        }}</button>
</mat-dialog-actions>
